var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "-10 -12 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 12,
    r: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.028 20.837c-.714 0-.593-.271-.839-.949l-2.103-6.92L22.263 3.37",
    fill: "#2381af"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.028 20.837c.552 0 .795-.252 1.105-.553l2.941-2.857-3.671-2.214",
    fill: "#15709c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.403 15.213l8.89 6.568c1.015.56 1.748.271 2-.942l3.62-17.053c.372-1.487-.564-2.159-1.534-1.72L1.125 10.263c-1.45.582-1.443 1.392-.264 1.753l5.455 1.7L18.94 5.753c.595-.36 1.143-.167.694.232",
    fill: "currentColor"
  })));
}
export default "data:image/svg+xml,%3csvg width='48' height='48' viewBox='-10 -12 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3ccircle cx='14' cy='12' r='24' fill-rule='evenodd'%3e%3c/circle%3e %3cpath d='M9.028 20.837c-.714 0-.593-.271-.839-.949l-2.103-6.92L22.263 3.37' fill='%232381af' /%3e %3cpath d='M9.028 20.837c.552 0 .795-.252 1.105-.553l2.941-2.857-3.671-2.214' fill='%2315709c' /%3e %3cpath d='M9.403 15.213l8.89 6.568c1.015.56 1.748.271 2-.942l3.62-17.053c.372-1.487-.564-2.159-1.534-1.72L1.125 10.263c-1.45.582-1.443 1.392-.264 1.753l5.455 1.7L18.94 5.753c.595-.36 1.143-.167.694.232' fill='currentColor' /%3e %3c/svg%3e";
export { SvgTelegram as ReactComponent };